
import LocalStorageService from '../services/LocalStorageService';
import MeveoClient from "../model/MeveoClient";
import Error from '../model/Error';
import Customer from '../model/account/Customer';
import UserService from '../services/UserService';
import ClientService from '../services/ClientService';
import EventDispatcher from "../framework/EventDispatcher";
import ApplicationStore from '../framework/ApplicationStore';

export const GET_USER = 'GET_USER';
export const INITIALIZE_USER = 'INITIALIZE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export default function reducer(state = {user: null}, action = {}) {
	switch (action.type) {
		case EventDispatcher.successAction(GET_USER):
		case EventDispatcher.successAction(INITIALIZE_USER):
		const {user, authEmail} = action.data;
		return {
			...state,
			user,
			authEmail
		};
		break;
		case EventDispatcher.successAction(UPDATE_USER):
		const {customer} = action.data;
		return {
			...state,
			customer
		};
		break;
		default:
		return state;
	}
}

export function updateUser(data) {
	return dispatch => {
		ClientService.UpdateUser(data)
			.then(response => {
				if (response === null || response.status === "FAIL") {
					this.fail(response);
				} else {
					const currentCustomer = LocalStorageService.getCurrentCustomer();
					const customer = {...currentCustomer};
					customer.success = "success";
					EventDispatcher.success(dispatch, UPDATE_USER, {customer});
				}
			})
			.catch(error => {
				EventDispatcher.error(dispatch, UPDATE_USER, error);
			});
		}
	}


	export function findUser(username) {
		return (dispatch, getState) => {
			UserService.findUser(username)
				.then(response => {
					const {actionStatus, user} = response;
					if (actionStatus === null) {
						throw null;
					} else if (actionStatus.status === "SUCCESS") {
						/*const userAccess = userDetails["resource_access"] || {};
						const scUserAccess = userAccess["opencell-sc"] || {};
						const userRoles = scUserAccess["roles"] || [];
						const isSCCustomer = userRoles.indexOf("customer") !== -1;
						const {createdAt, lastLoginDate} = user || "";*/

						EventDispatcher.success(dispatch, GET_USER, {user});
					} else {
						 throw actionStatus;
					}
				})
				.catch(error => {
					const {response = {}} = error;
					const {messages: mainMessages={}} = getState();
					const {messages = {}} = mainMessages || {};
					const message = ((response.status === 401) ? messages["common.error.access.denied"] : error.message);
					EventDispatcher.error(dispatch, GET_USER, message);
				});
	}
	}
	export function initializeUser(auth, resume) {
		const {idTokenParsed} = auth;
		return (dispatch, getState) => {
			const userDetails = auth && auth.tokenParsed || {};
			const userName = userDetails["preferred_username"] || null;
			UserService.findUser(userName)
			.then(response => {
				const {actionStatus, user} = response;
				const userDetails = auth && auth.tokenParsed || {};
				const userName = userDetails["preferred_username"] || null;
				const userEmail = userDetails.email;
				if (actionStatus === null) {
					throw null;
				} else if (actionStatus.status === "SUCCESS") {
					EventDispatcher.success(dispatch, INITIALIZE_USER, {"user": user, "authEmail": userEmail});
					resume(user);
				} else {
					throw actionStatus;
				}
			})
			.catch(error => {
				const {response = {}} = error;
				const {messages: mainMessages={}} = getState();
				const {messages = {}} = mainMessages || {};
				const message = ((response.status === 401) ? messages["common.error.access.denied"] : error.message);
				EventDispatcher.error(dispatch,  INITIALIZE_USER, message);
				resume(null, new Error({message}))
			});
		}
	}

	export function createAccount(userDetails, resume) {
		const newAccount = new MeveoClient({
			userName: userDetails["preferred_username"],
			email: userDetails["email"],
			firstName: userDetails["given_name"],
			lastName: userDetails["family_name"]
		});

		return this.opencellAPI.createCRMAccountHierarchy(newAccount)
			.then(() => {
				return this.findUser(newAccount.code)

			})
			.then(response => {
				const {actionStatus, user} = response;
				if (actionStatus === null) {
					throw null;
				} else {
					resume(user);
				}
			})
			.catch(error => {
				const {response = {}} = error;
				const {messages: mainMessages={}} = ApplicationStore.getState();
				const {messages = {}} = mainMessages || {};
				const message = ((response.status === 401) ? messages["common.error.access.denied"] : error.message);
				resume(null, new Error({message}));
			});
	}

	export function loginUser(login, resume) {
		CommonService.login(login)
			.then(response => {
				const {actionStatus, customers} = response;
				const {customer} = customers || {};
				const [firstCustomer] = customer || [];
				if (actionStatus === null || actionStatus.status === "FAIL") {
					resume && resume(new Error(actionStatus));
				} else if (firstCustomer === null) {
					resume && resume(new Error({message: "Customer is not yet registered."}));
				} else {
					resume && resume();
				}
			})
			.catch(error => {
				const {response = {}} = error;
				if (response.status === 401) {
					resume && resume(new Error({message: "Invalid user name or password."}))
				} else {
					resume && resume(new Error(error));
				}
			});
	}



// WEBPACK FOOTER //
// ./src/opencell/actions/UserActions.js